
<template>
  <!--新增推送-->
  <x-addEdit
    :formList="formList"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
    :itemLayout="$store.state.long_itemLayout"
  >
    <template slot="publishTime" slot-scope="{formItem}">
      <a-form-item class="publish-time" :label="formItem.label" required v-bind="$store.state.long_itemLayout">
        <a-row type="flex">
          <a-col>
            <a-form-item>
              <a-radio-group @change="publishChange" v-decorator="formItem.props">
                <a-radio :value="0">立即发布</a-radio>
                <a-radio :value="1">定时发布</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item>
              <a-date-picker v-decorator="formItem.dateProps" :disabled="formItem.pickerDisabled" showTime format="YYYY-MM-DD HH:mm:ss"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form-item>
    </template>
  </x-addEdit>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect, mixin.addEdit],
  name: 'addPush',
  data () {
    return {
      actionsList: [],
      selectList: [],
      base_itemLayout: {
        labelCol: {span: 5},
        wrapperCol: {span: 8}
      },
      formKey: {
        title: '',
        content: '',
        type: '',
        is_delay: '',
        delay_time: '',
        push_os: '',
        push_app: '',
        scope_type: '',
        scope: '',
        open_type: '',
        intent: '',
        urlType: '',
        url: '',
        param: ''
      },
      formList: [
        {
          label: '推送标题',
          inputType: 'input',
          options: [],
          placeholder: '请输入推送标题',
          props: ['title', {
            validateTrigger: 'blur',
            rules: [
              {required: true, message: '请输入推送标题'},
              {min: 1, max: 50, message: '标题为1-50个字'}
            ]
          }]
        },
        {
          label: '推送内容',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入推送内容',
          props: ['content', {
            validateTrigger: 'blur',
            rules: [
              {required: true, message: '请输入推送内容'},
              {min: 1, max: 100, message: '模板ID为1-100个字'}
            ]
          }]
        },
        {
          slot: 'publishTime',
          label: '发布时间',
          inputType: 'radioGroup',
          options: [],
          pickerDisabled: true,
          props: ['is_delay', {
            initialValue: 0,
            rules: [{required: true, message: '请选择发布时间'}]
          }],
          dateProps: ['delay_time',
            {
              rules: [{required: false, message: '请选择定时发布时间'}]
            }
          ]
        },
        {
          label: '目标平台',
          inputType: 'checkboxGroup',
          options: [],
          placeholder: '',
          props: ['push_os', {
            initialValue: [],
            rules: [{required: true, message: '请选择目标平台'}]
          }]
        },
        {
          label: '目标应用',
          inputType: 'radioGroup',
          options: [],
          placeholder: '',
          handle: this.pushAppChange,
          props: ['push_app', {
            initialValue: 1,
            rules: [{required: true, message: '请选择目标应用'}]
          }]
        },
        {
          label: '用户范围',
          inputType: 'select',
          options: this.$store.state.userRange,
          placeholder: '请选择用户范围',
          handle: this.handleUserRange,
          props: ['scope_type', {
            rules: [{required: true, message: '请选择用户范围'}]
          }]
        },
        {
          label: '选择城市',
          inputType: 'treeSelect',
          options: [],
          placeholder: '请选择城市',
          treeCheckable: true,
          key: 'city',
          props: ['city_scope', {
            rules: [{required: true, message: '请选择城市'}]
          }]
        },
        {
          label: '选择小区',
          inputType: 'transfer',
          options: [],
          placeholder: '',
          key: 'community',
          props: ['community_scope', {
            rules: [{required: true, message: '请选择小区'}]
          }],
          titles: ['小区列表', '已选']
        },
        {
          label: '输入账号',
          inputType: 'textarea',
          extra: '多个账号以英文“,”逗号隔开',
          key: 'account',
          props: ['account_scope', {
            rules: [{required: true, message: '请输入账号'}]
          }]
        },
        {
          label: '点击后续动作',
          inputType: 'select',
          options: [],
          placeholder: '请选择指定页面',
          handle: (e, param) => this.handleOpenType(e, param),
          props: ['open_type', {
            rules: [{required: true, message: '请选择后续动作'}]
          }]
        },

        {
          label: 'URL类型',
          inputType: 'select',
          options: [],
          placeholder: '请选择URL类型',
          key: 'urlType',
          props: ['urlType', {
            rules: [{required: true, message: '请选择指定页面'}]
          }]
        },
        {
          label: 'URL',
          inputType: 'input',
          options: [],
          placeholder: '输入要打开的URL',
          key: 'url',
          props: ['url', {
            rules: [
              {required: true, message: '请输入url链接'},
              {type: 'url', message: '请输入正确的url格式'}
            ]
          }]
        },

        {
          label: '指定页面',
          inputType: 'select',
          options: [],
          placeholder: '选择指定页面',
          key: 'page',
          props: ['intent', {
            rules: [{required: true, message: '请选择指定页面'}]
          }]
        }
      ],
      addParam: {
        url: '/push',
        reqHandle: this.reqHandle,
        resHandle: '' // this.addResHandle
      },
      editParam: {},
      detailParam: {
        url: '/push/',
        resHandle: '' // this.detailResHandle
      }
    };
  },
  created () {
    this.getSelect();
  },
  mounted () {
    let keyArr = [
      'intent', 'urlType', 'url' // 推送通知点击后续动作的key
    ];
    this.formList.forEach((el) => {
      let isSame = keyArr.some(item => item === (el.props && el.props[0]));
      isSame && (el.isShow = false);
    });
  },
  methods: {
    getSelect () {
      let paramArr = [
        { index: 3, query: 'push_aims_type_desc', scope: 'formList' },
        { index: 4, query: 'message_aims_type_desc', scope: 'formList' },
        { index: 5, query: 'scope_type_desc', scope: 'formList' }
      ];
      paramArr.forEach((el) => {
        this.typeSelect(el);
      });

      this.typeSelect({
        query: 'click_push_type_desc',
        format: '2',
        handle: (data) => {
          let obj = {};
          data.forEach((el) => {
            obj[el.value] = el.children;
          });
          this.selectList = obj;
        }
      });

      this.userRangeList(6, 7);
    },
    /* 目标应用change */
    pushAppChange (e) {
      let val = e.target.value;
      this.$children[0].form.resetFields(['open_type', 'intent', 'urlType', 'url']);
      this.formList.forEach((el, index) => {
        if (el.props && el.props[0] === 'open_type') {
          el.options = this.selectList[val];
          this.actionsList = this.selectList[val];
        }
      });
    },
    /* 处理点击后续动作输入框 */
    handleOpenType (val, param) {
      this.$children[0].form.resetFields('page', 'urlType', 'url');
      let list = [];
      this.actionsList.forEach((item) => {
        if (item.value === val) {
          list = item.children;
        }
      });

      let keyObj = {
        open_app_page: 'page',
        open_link: 'urlType'
      };
      this.formList.forEach((el) => {
        if (keyObj[val] && el.key === keyObj[val]) {
          el.options = list;
        }
      });

      let openTypeObj = {
        open_app: { page: false, urlType: false, url: false },
        open_app_page: { page: true, urlType: false, url: false },
        open_link: { page: false, urlType: true, url: true }
      };
      this.handleDynamicForm(val, openTypeObj);
    },
    /* 发布时间 change */
    publishChange (e) {
      this.handleDealyTime(e.target.value);
    },
    /* 处理用户范围 */
    handleUserRange (val) {
      let userTypeObj = {
        0: { city: false, community: false, account: false },
        1: { city: true, community: false, account: false },
        2: { city: false, community: true, account: false },
        3: { city: false, community: false, account: true }
      };
      this.handleDynamicForm(val, userTypeObj);
    },
    reqHandle (param) {
      param.delay_time && (param.delay_time = param.delay_time.format('YYYY-MM-DD HH:mm:ss'));
      if (new Date(param.delay_time).getTime() < new Date().getTime()) {
        this.$message.error('推送时间不能小于当前时间');
        return;
      }
      param.type = 1; // 默认提交消息类型为公告
      param.urlType && (param.intent = param.urlType);
      param = this.rangeReqVal(param);
      return param;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/marketing/push/addPush.vue